import React from "react";
import styled from "styled-components";
import RowIntroductionStreamItem from "./RowIntroductionStreamItem";
import Wrapper from "../atoms/Wrapper";
import InfiniteScroll from "./InfiniteScroll";
import CircularProgress from "@material-ui/core/CircularProgress";

const StyledWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  color: ${props => props.theme.colors.black100};
  box-sizing: border-box;
  width: fit-content;
  ${props => (props.left ? "" : "justify-content: center;")}
`;

const Message = styled(Wrapper)`
  padding-top: 1rem;
  padding-left: 0.6rem;
  color: ${props => props.theme.colors.gray};
`;

const ISWrapper = styled(Wrapper)`
  flex-wrap: nowrap;
  width: fit-content;
  padding: 0 1rem;
`;

const RowIntroductionStream = props => {
  return (
    <StyledWrapper>
      {props.requestState === "failure" ? (
        <Message>読み込みに失敗しました</Message>
      ) : (
        <InfiniteScroll
          element={ISWrapper}
          pageStart={0}
          loadMore={props.loadMore}
          hasMore={props.hasMore}
          initialLoad
          loader={<CircularProgress key="vtuber_stream_loading" />}
          requestState={props.requestState}
          page={props.page}
          style={{ justifyContent: "center" }}
        >
          {props.items.map((item, idx) => (
            <RowIntroductionStreamItem item={item} key={idx} />
          ))}
        </InfiniteScroll>
      )}
    </StyledWrapper>
  );
};

export default RowIntroductionStream;
